import { Base64 } from 'js-base64';
import { sendRequest } from '../common/sendRequest';
import * as settings from './settings';

export function login(login, password) {
  let headers = {};
  headers['Authorization'] = 'Basic ' + Base64.encode(login + ":" + password);
  return sendRequest(settings.ServerURL, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      operation: 'login'
    })
  });
}

export function refreshAccessToken(refreshToken) {
  return sendRequest(settings.ServerURL, {
    method: 'POST',
    body: JSON.stringify({
      operation: 'refresh_token',
      token: refreshToken
    })
  });
}



// WEBPACK FOOTER //
// ./src/services/auth.js